module.exports = __webpack_public_path__ + "img/applicants-selection-chosen.6ed1c487.svg";